import {
  GET_DISPENSARY_LIST, GET_DISPENSARY_LIST_COMPLETED, GET_DISPENSARY_LIST_FAILED,
  SELECT_DISPENSARY,
  ADD_DISPENSARY, ADD_DISPENSARY_COMPLETED, ADD_DISPENSARY_FAILED,
  UPDATE_DISPENSARY, UPDATE_DISPENSARY_COMPLETED, UPDATE_DISPENSARY_FAILED,
  GET_DISPENSARY, GET_DISPENSARY_COMPLETED, GET_DISPENSARY_FAILED,
  SEARCH_DISPENSARIES, SEARCH_DISPENSARIES_COMPLETED, SEARCH_DISPENSARIES_FAILED,
} from "./actions";
import {RESTORE_STATE} from "../persistState";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  dispensaryList: [],
  dispensaryListLoading: false,
  dispensaryListError: null,
  dispensary: null,
  dispensaryLoading: false,
  dispensaryError: null,
  selectedDispensaryId: '',
  addingDispensary: false,
  updatingDispensary: false,
  search: searchDefault,
};

function dispensaryReducer(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_DISPENSARIES: return handleSearch(state, 'search', action.payload);
    case SEARCH_DISPENSARIES_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_DISPENSARIES_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case RESTORE_STATE: {
      const {selectedDispensaryId} = (action.payload && action.payload.dispensary) || {selectedDispensaryId: ''};
      return {
        ...state,
        selectedDispensaryId,
      };
    }
    case GET_DISPENSARY_LIST: {
      return {
        ...state,
        dispensaryListLoading: true,
        dispensaryList: [],
        dispensaryListError: null,
      };
    }
    case GET_DISPENSARY_LIST_COMPLETED: {
      return {
        ...state,
        dispensaryListLoading: false,
        dispensaryList: action.payload.data,
      };
    }
    case GET_DISPENSARY_LIST_FAILED: {
      return {
        ...state,
        dispensaryListLoading: false,
        dispensaryListError: action.payload,
      };
    }
    case GET_DISPENSARY: {
      return {
        ...state,
        dispensaryLoading: true,
        dispensary: null,
        dispensaryError: null,
      };
    }
    case GET_DISPENSARY_COMPLETED: {
      return {
        ...state,
        dispensaryLoading: false,
        dispensary: action.payload,
      };
    }
    case GET_DISPENSARY_FAILED: {
      return {
        ...state,
        dispensaryLoading: false,
        dispensaryError: action.payload,
      };
    }
    case SELECT_DISPENSARY: {
      return {
        ...state,
        selectedDispensaryId: action.payload.dispensaryId,
      };
    }
    case ADD_DISPENSARY: {
      return {
        ...state,
        addingDispensary: true,
      };
    }
    case ADD_DISPENSARY_COMPLETED: {
      return {
        ...state,
        addingDispensary: false,
      };
    }
    case ADD_DISPENSARY_FAILED: {
      return {
        ...state,
        addingDispensary: false,
      };
    }
    case UPDATE_DISPENSARY: {
      return {
        ...state,
        updatingDispensary: true,
      };
    }
    case UPDATE_DISPENSARY_COMPLETED: {
      return {
        ...state,
        updatingDispensary: false,
      };
    }
    case UPDATE_DISPENSARY_FAILED: {
      return {
        ...state,
        updatingDispensary: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
}

export default dispensaryReducer;



// WEBPACK FOOTER //
// ./src/Dispensary/reducer.js